import {
  candela_cat_10,
  continuous,
  discrete
} from '@/utils/colors'

export const SettingTypes = {
  get Bool() { return 'boolean' },
  get ColorContinuous() { return 'color-continuous' },
  get ColorDiscrete() { return 'color-discrete' },
  get ColorSingle() { return 'color-single' },
  get Enum() { return 'enum' },
  get NumberContinuous() { return 'number-continuous' },
  get NumberDiscrete() { return 'number-discrete' },
  get NumberRange() { return 'number-range' }
}

export const create_bool = params => {
  if(!params) throw new Error('Parameter "params" missing in: create_bool(params)')

  let def = params.default !== undefined ? params.default : false
  let value = params.value !== undefined ? params.value : def

  if(params.default !== undefined) def = params.default

  return {
    get default() { return def },
    get label() { return params.label || 'Untitled Bool' },
    reset() { value = def },
    get type() { return SettingTypes.Bool },
    get value() { return value },
    set value(b) { if(typeof b === typeof value) value = b }
  }
}

export const create_continuous_colors = params => {
  if(!params) throw new Error('Parameter "params" missing in: create_continuous_colors(params)')

  let def = params.default || 0
  let value = params.value || def

  return {
    get default() { return params.default || def },
    get label() { return params.label || 'Untitled Continuous Color' },
    get idx() { return value },
    get options() { return params.options || continuous },
    reset() { value = params.default || def },
    get type() { return SettingTypes.ColorContinuous },

    get value() { return (params.options || continuous)[value] },
    set value(v) { if(v !== undefined) value = v }
  }
}

export const create_single_color_picker = params => {
  if(!params) throw new Error('Parameter "params" missing in: create_single_color_picker(params)')

  let def = params.default || 0
  let value = params.value || def

  return {
    get default() { return params.default || def },
    get label() { return params.label || 'Untitled Single Color Picker' },
    get idx() { return value },
    get options() { return params.options || candela_cat_10.colors },
    reset() { value = params.default || def },
    get type() { return SettingTypes.ColorSingle },

    get value() { return (params.options || candela_cat_10.colors)[value] },
    set value(v) { if(v !== undefined) value = v }
  }
}

export const create_discrete_colors = params => {
  if(!params) throw new Error('Parameter "params" missing in: create_discrete_colors(params)')

  let def = params.default || 0
  let value = params.value || def

  return {
    get default() { return params.default || def },
    get label() { return params.label || 'Untitled Discrete Color' },
    get idx() { return value },
    get options() { return params.options || discrete },
    reset() { value = params.default || def },
    get type() { return SettingTypes.ColorDiscrete },

    get value() { return (params.options || discrete)[value] },
    set value(v) { if(v !== undefined) value = v }
  }
}

export const create_discrete_number = params => {
  if(!params) throw new Error('Parameter "params" missing in: create_discrete_number(params)')

  let def = 1
  let value = params.value !== undefined ? params.value : 1
  let min = params.min !== undefined ? params.min : 0
  let max = params.max !== undefined ? params.max : 0

  if(params.default !== undefined) def = params.default

  return {
    get default() { return def },
    get label() { return params.label || 'Untitled Discrete Number' },
    get idx() { return value },
    get max() { return max },
    get min() { return min },
    reset() { value = 0 },
    get type() { return SettingTypes.NumberDiscrete },

    get value() { return value },
    set value(n) { if(n >= min && n <= max) value = n }
  }
}

export const create_continuous_number = params => {
  if(!params) throw new Error('Parameter "params" missing in: create_continuous_number(params)')

  let value = params.value || 0.5

  return {
    get default() { return params.default || 0.5 },
    get label() { return params.label || 'Untitled' },
    get max() { return params.max || 1 },
    get min() { return params.min || 0 },
    reset() { value = params.default || 0.5 },
    get step() { return params.step || 0.01 },
    get type() { return SettingTypes.NumberContinuous },

    get value() { return value },
    set value(n) { if(typeof n === typeof value) value = n }
  }
}

export const create_enum = params => {
  if(!params) throw new Error('Parameter "params" is missing in: create_enum(params)')
  if(!params.options) throw new Error('Parameter "params" does not have an "options" property in: create_enum(params)')

  let value = params.value !== undefined ? params.value : 0
  return {
    get default() { return params.options[0] },
    get label() { return params.label || 'Untitled' },
    get options() { return params.options },
    reset() { value = 0 },
    get type() { return SettingTypes.Enum },
    get value() { return value },
    set value(i) { value = i }
  }
}

export const create_range_number = params => {
  if(!params) throw new Error('Parameter "params" missing in: create_range_number(params)')

  let value = params.value || [0, 1.0]

  return {
    get default() { return params.default || [0, 1.0] },
    get label() { return params.label || 'Untitled' },
    get range() { return params.range || [0, 1.0] },
    reset() { value = params.default || [0, 1.0] },
    get step() { return params.step || 0.01 },
    get type() { return SettingTypes.NumberRange },

    get value() { return value },
    set value(n) { if(typeof n === typeof value) value = n }
  }
}
